import { NARGControlSheetV05 } from "api/resources/models/AutoGenerated";

export const valuesConverter = (data: NARGControlSheetV05[]) => {
  return data.map((row) => {
    return {
      ...row,
      isThirdParty: row.isThirdParty ? 'TRUE' : 'FALSE',
      possibleTotalLoss: row.possibleTotalLoss ? 'TRUE' : 'FALSE',
    };
  });
};
